export default "__VITE_ASSET__1dd5f318__"